/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-dialog-actions[_ngcontent-%COMP%]{justify-content:flex-end}h1.mat-dialog-title[_ngcontent-%COMP%]{float:left}div.wrapperAddNewSubject[_ngcontent-%COMP%]{float:right;margin-bottom:1em}table.tblCCBCSubjects[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:.5em 10px}"];
export { styles as styles };
